/**
 * Contact operations — list, add, remove.
 */

import type { ArbiClient } from '@arbidocs/client'
import { requireData, requireOk } from '../errors.js'

export async function listContacts(arbi: ArbiClient) {
  return requireData(await arbi.fetch.GET('/v1/user/contacts'), 'Failed to fetch contacts')
}

export async function addContacts(arbi: ArbiClient, emails: string[]) {
  return requireData(
    await arbi.fetch.POST('/v1/user/contacts', { body: { emails } }),
    'Failed to add contacts'
  )
}

export async function removeContacts(arbi: ArbiClient, contactIds: string[]) {
  requireOk(
    await arbi.fetch.DELETE('/v1/user/contacts', { body: { contact_ids: contactIds } }),
    'Failed to remove contacts'
  )
}

/**
 * Group contacts by registration status.
 * Returns registered contacts and pending (not yet registered) contacts.
 */
export function groupContactsByStatus<T extends { status: string }>(
  contactList: T[]
): { registered: T[]; pending: T[] } {
  const registered: T[] = []
  const pending: T[] = []
  for (const c of contactList) {
    if (c.status === 'registered') {
      registered.push(c)
    } else {
      pending.push(c)
    }
  }
  return { registered, pending }
}
